import axiosInstance from './api';
import { urlBase64ToUint8Array } from '../send-sw-details';

const VAPID_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA"; // Replace with your actual VAPID public key

// Add service worker registration function
export const registerServiceWorker = async () => {
  try {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.register("./sw.js");
      console.log("Service Worker registered successfully", registration);
      return registration;
    }
    return null;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
    return null;
  }
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const subscribeToPushNotifications = async (userId) => {
  try {
    // First ensure service worker is registered
    let registration = await navigator.serviceWorker.ready;
    if (!registration) {
      registration = await registerServiceWorker();
      if (!registration) {
        throw new Error('Service Worker registration failed');
      }
    }

    const push = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });

    await axiosInstance.post('/push-notification/subscription', {
      userId,
      subscription: JSON.stringify(push)
    });

    return true;
  } catch (error) {
    console.error('Error subscribing to push notifications:', error);
    return false;
  }
};

export const unsubscribeFromPushNotifications = async (userId) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
      await subscription.unsubscribe();
      
      await axiosInstance.post('/push-notification/unsubscription', {
        userId
      });
    }
    
    return true;
  } catch (error) {
    console.error('Error unsubscribing from push notifications:', error);
    return false;
  }
};

/**
 * Send a welcome test notification to a new user
 * This is triggered when a user installs the app for the first time
 * @param {string} userId - The ID of the user to send the notification to
 * @returns {Promise<boolean>} - Whether the notification was sent successfully
 */
export const sendWelcomeTestNotification = async (userId) => {
  try {
    // First check if notifications are supported and permitted
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return false;
    }
    
    if (Notification.permission !== 'granted') {
      console.log("Notification permission not granted");
      return false;
    }

    // Send the welcome notification via the server API
    await axiosInstance.post('/user/send-push-notification', {
      userId: userId,
      title: 'Welcome to Estate App!',
      body: 'Thanks for installing our app. This is a test notification to confirm everything is working correctly.',
      is_save: true
    });
    
    console.log('Welcome test notification sent successfully');
    return true;
  } catch (error) {
    console.error('Error sending welcome test notification:', error);
    return false;
  }
};